export default class InvalidExpiryError extends Error {
	constructor() {
		super("Expiry date cannot be earlier than today.");
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
